<template>
  <div class="myorder uinfo_order">
    <div class="myorder__box">
      <div class="myorder__box_title">
        <a @click="toOrder(0)">全部预约</a>
        我的预约
      </div>
      <ul>
        <li>
          <div @click="toOrder(1)" class="box">
            <div class="icon i3"></div>
            <p>待使用</p>
          </div>
        </li>
        <li>
          <div @click="toOrder(2)" class="box">
            <div class="icon i2"></div>
            <p>已退订</p>
          </div>
        </li>
        <li>
          <div @click="toOrder(3)" class="box">
            <div class="icon i1"></div>
            <p>已完成</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      
      // radio:String,
      // loaded:Boolean,
      // fl_stadium_list:Array,
    },
    data() {
      return {
  
      }
    },
    created() {},
    mounted() {
  
    },
    methods:{
      toOrder(item){
        this.$emit('toOrder',item)
      },
      // toOpenVideo(){
      //   this.$emit('toOpenVideo')
      // },
      // toOpenDesc(){
      //   this.$emit('toOpenDesc')
      // }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .uinfo_order {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    margin-bottom: 8*@vm_base;
  }
  .myorder {
    margin-top: 16*@vm_base;
    padding: 0 30*@vm_base;
    clear: both;
    .myorder__box {
      width: 100%;
      padding: 0 30*@vm_base;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.08);
      border-radius: 20*@vm_base;
    }
    .myorder__box_title {
      padding: 32*@vm_base 0*@vm_base 52*@vm_base 0*@vm_base;
      font-size: 28*@vm_base;
      color: #282828;
      font-weight: 600;
      a {
        float: right;
        padding-right: 30*@vm_base;
        font-size: 25*@vm_base;
        font-weight: lighter;
        color: #999999;
        background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
        background-size: 18*@vm_base auto;
      }
    }
    .tit {
      padding: 32*@vm_base 0 50*@vm_base 0;
      border-bottom: 1px solid #eee;
      font-size: 28*@vm_base;
      height: 28*@vm_base;
      line-height: 28*@vm_base;
      font-weight: 400;
      color: #282828;
      font-weight: 600;
      a {
        float: right;
        padding-right: 30*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 300;
        color: #999999;
        background: url(../../assets/images/base/icon_arrow.png) right center no-repeat;
        background-size: 16*@vm_base auto;
      }
    }
    ul {
      display: flex;
      overflow: auto;
      padding: 0 0 42*@vm_base 0;
  
      li {
        flex: 1;
        text-align: center;
        font-size: 24*@vm_base;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 33*@vm_base;
  
        p {
          color: #282828;
          font-weight: lighter;
        }
      }
  
      .icon {
        width: 52*@vm_base;
        height: 52*@vm_base;
        margin: 0 auto 10*@vm_base auto;
        // background-size:44*@vm_base auto auto;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 50*@vm_base auto;
      }
  
      .i1 {
        background-image: url(../../assets/images/base/comparead.png);
      }
  
      .i2 {
        background-image: url(../../assets/images/base/comphalf.png);
      }
  
      .i3 {
        background-image: url(../../assets/images/base/compend.png);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/subgroup/myPanelFunctionOrder.vue